import React from "react";
import $ from "jquery";

class Landing extends React.Component {

  constructor(props) {
    super(props);
    var that = this;
    this.state = {
      mode: "mobile",
    }
    this.resize();
    $(window).resize(function () {
      that.resize();
    });
  }

  componentDidMount() {

  }

  resize() {
    var that = this;
    if ($(window).width() > $(window).height()) {
      if (this.state && this.state.mode === 'mobile') {
        that.setState({
          mode: 'web'
        });
      }
    }
    else {
      if (this.state && this.state.mode === 'web') {
        that.setState({
          mode: 'mobile'
        });
      }
    }
  }

  render() {
    var images = [
      './assets/images/landing/IMG-20231207-WA0004.png',
      './assets/images/landing/IMG-20231207-WA0003.png',
      './assets/images/landing/IMG-20231207-WA0005.png'
    ]
    var list = (images.map(function (item) {
      return <img src={item} class='smallimage' />;
    }));

    return (
      <div class='fullwidthcontainer'>
        <div class='fullwidthcontainer'>
          <img src="./assets/images/landing/IMG-20231117-WA0016.png" class='bigimage' />
        </div>
        <div class='fullwidthcontainer'>
          {list}
        </div>
      </div>
    );
  }
}

export default (Landing);
